import React from "react";
import classes from "./ViewerButtons.module.css";
import ScreenShotButton from "./Buttons/ScreenShotButton";
import MeasureButton from "./Buttons/MeasureButton";
import ClippingButton from "./Buttons/ClippingButton";
import ExportExcelButton from "./Buttons/ExportExcelButton";
import ShowTreeButton from "./Buttons/ShowTreeButton";
import ShowPropsButton from "./Buttons/ShowPropsButton";
function ViewerButtons() {
    return (
        <div className={classes.buttons_wrap}>
            <div className={classes.buttons_subwrap}>
                <ShowTreeButton />
                <ExportExcelButton />
                <ScreenShotButton />
                <MeasureButton />
                <ClippingButton />
                <ShowPropsButton />
            </div>
        </div>
    );
}

export default ViewerButtons;
// console.log('hello');
